// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    height: 100vh;
}
.page-loader-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
.loader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: relative;
    border: 3px solid;
    border-color: #000000 #0000 #000000 #0000;
    border-radius: 50%;
    box-sizing: border-box;
    animation: 1s rotate linear infinite;
}
.loader:before, .loader:after {
    content: '';
    top: 0;
    left: 0;
    position: absolute;
    border: 10px solid transparent;
    border-bottom-color: #000000;
    transform: translate(-10px, 19px) rotate(-35deg);
}
.loader:after {
    border-color: #000000 #0000 #0000 #0000;
    transform: translate(32px, 3px) rotate(-35deg);
}
.builder-loader{
    text-align: center;
    font-size: 20px;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;
}
.builder-loader img{
    height: 100px;
    width: 100px;
    margin-bottom: 20px;
}
@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/loader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,8BAA8B;IAC9B,4BAA4B;IAC5B,gDAAgD;AACpD;AACA;IACI,uCAAuC;IACvC,8CAA8C;AAClD;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["body {\n    height: 100vh;\n}\n.page-loader-center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n}\n.loader {\n    width: 48px;\n    height: 48px;\n    display: inline-block;\n    position: relative;\n    border: 3px solid;\n    border-color: #000000 #0000 #000000 #0000;\n    border-radius: 50%;\n    box-sizing: border-box;\n    animation: 1s rotate linear infinite;\n}\n.loader:before, .loader:after {\n    content: '';\n    top: 0;\n    left: 0;\n    position: absolute;\n    border: 10px solid transparent;\n    border-bottom-color: #000000;\n    transform: translate(-10px, 19px) rotate(-35deg);\n}\n.loader:after {\n    border-color: #000000 #0000 #0000 #0000;\n    transform: translate(32px, 3px) rotate(-35deg);\n}\n.builder-loader{\n    text-align: center;\n    font-size: 20px;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    display: flex;\n}\n.builder-loader img{\n    height: 100px;\n    width: 100px;\n    margin-bottom: 20px;\n}\n@keyframes rotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
